/**
 * Shared vehicle localStorage helper.
 *
 * Stores the user's selected vehicle so it persists across pages.
 * Dispatches a "vehicle:changed" CustomEvent on window whenever the
 * selection is saved or cleared.
 *
 * Shape stored under key "selectedVehicle":
 * {
 *   makeSlug, makeName,
 *   modelSlug, modelName,
 *   trimId, trimName,
 *   specs: { pcd, center_bore, et_front, et_rear, diameter_front, diameter_rear, ... }
 * }
 */

const STORAGE_KEY = 'selectedVehicle';

function dispatch(vehicle) {
  window.dispatchEvent(
    new CustomEvent('vehicle:changed', { detail: { vehicle } })
  );
}

export function getVehicle() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveVehicle(vehicle) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(vehicle));
  } catch {
    /* storage full – ignore */
  }
  dispatch(vehicle);
}

export function clearVehicle() {
  localStorage.removeItem(STORAGE_KEY);
  dispatch(null);
}
